__webpack_require__.p = "/interactive/nar/equity-advantage/";